import { render, staticRenderFns } from "./UpdateLogWraper.vue?vue&type=template&id=51722d56&scoped=true"
import script from "./UpdateLogWraper.vue?vue&type=script&lang=js"
export * from "./UpdateLogWraper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51722d56",
  null
  
)

export default component.exports